'use client';
var countItems = function(navigationItems, helpCenterItems, showMore) {
    if ((navigationItems == null ? void 0 : navigationItems.length) && (helpCenterItems == null ? void 0 : helpCenterItems.length)) {
        var amount = navigationItems.length + helpCenterItems.length;
        return showMore ? amount + 1 : amount;
    }
    if (navigationItems == null ? void 0 : navigationItems.length) {
        /* ShowMore не отображается без helpCenterItems */ return navigationItems.length;
    }
    if (helpCenterItems == null ? void 0 : helpCenterItems.length) {
        return showMore ? helpCenterItems.length + 1 : helpCenterItems.length;
    }
    return 0;
};

export { countItems };
